import LocationOnIcon from '@mui/icons-material/LocationOn';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function LocalisationIcon(props: FixMe) {
  return <LocationOnIcon {...props} />;
}

export default LocalisationIcon;
